import CitySEOHead from "@/components/feature/CitySEOHead";
import CocoaBeachHeroSection from "./components/HeroSection";
import CocoaBeachStickyNav from "./components/StickyNav";
import CocoaBeachProcessingTimeSection from "./components/ProcessingTimeSection";
import CocoaBeachServicesSection from "./components/ServicesSection";
import CocoaBeachLocalAreaSection from "./components/LocalAreaSection";
import CocoaBeachTestimonialsSection from "./components/TestimonialsSection";
import CocoaBeachAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CocoaBeachComparisonSection from "./components/ComparisonSection";
import CocoaBeachMistakesSection from "./components/MistakesSection";
import CocoaBeachHowItWorksSection from "./components/HowItWorksSection";
import CocoaBeachFAQSection, { faqs } from "./components/FAQSection";
import CocoaBeachHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CocoaBeachFinalCTA from "./components/FinalCTA";
import CocoaBeachTravelTimingSection from "./components/TravelTimingSection";
import CocoaBeachDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Cocoa Beach, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Cocoa Beach, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Cocoa Beach, Cape Canaveral, Port Canaveral, and Space Coast travelers needing urgent, fast, or same-day passport help.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CocoaBeachPage() {
  return (
    <>
      <CitySEOHead
        city="Cocoa Beach"
        state="Florida"
        stateAbbr="FL"
        route="/cocoa-beach"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Cocoa Beach, Florida"
        geoPosition="28.3200;-80.6076"
        keywords="expedited passport Cocoa Beach, emergency passport Cocoa Beach FL, same day passport Cocoa Beach, fast passport Florida, passport renewal Cocoa Beach, Cocoa Beach passport courier, Port Canaveral passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-16"
      />

      <div className="font-sans">
        <CocoaBeachHeroSection />
        <CocoaBeachStickyNav />
        <CocoaBeachProcessingTimeSection />
        <CocoaBeachLocalAreaSection />
        <CocoaBeachServicesSection />
        <CocoaBeachTravelTimingSection />
        <CocoaBeachDestinationsSection />
        <CocoaBeachTestimonialsSection />
        <CocoaBeachAcceptanceFacilitiesSection />
        <CocoaBeachComparisonSection />
        <CocoaBeachMistakesSection />
        <CocoaBeachHowItWorksSection />
        <CocoaBeachFAQSection />
        <CocoaBeachHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cocoa-beach" state="FL" />
        <CocoaBeachFinalCTA />
      </div>
    </>
  );
}